// extracted by mini-css-extract-plugin
export default {"error_message":"AppTextArea_error_message__eqpcS","error_div":"AppTextArea_error_div__7rhg7"};